const getTableList = state => state?.placement?.getTable

const selectors = {
  getTableList,
}

export default selectors
